import React, { useContext } from 'react';
import { ISignOff, IReportDueDates, IReportingEntity, ICorporateRisk, IBaseComponentProps } from '../../types';
import { RiskMitigationActionProgressUpdateReviewList } from '../riskMitigationAction/RiskMitigationActionProgressUpdateReviewList';
import { RiskProgressUpdateReviewList } from '../risk/RiskProgressUpdateReviewList';
import { EntityStatus } from '../../refData/EntityStatus';
import { DataContext } from '../DataContext';
import { DraftReportHeader } from './DraftReportHeader';
import { DateService } from '../../services';
import { getUpdateReportingStage } from '../../refData/UpdateReportingStages';

interface IDraftReportRiskProps extends IBaseComponentProps {
    reportDates: IReportDueDates;
    report: Partial<ISignOff>;
    loadReport: () => void;
    preHeadingText?: string;
    approvedByText?: string;
}

export const DraftReportRisk = (props: IDraftReportRiskProps): React.ReactElement => {
    const { preHeadingText, reportDates, report, loadReport } = props;
    const { dataServices } = useContext(DataContext);

    const isOpen = (entity: IReportingEntity, updatesProp: string): boolean => entity.EntityStatusID === EntityStatus.Open || entity[updatesProp]?.length > 0;
    const stage: string = getUpdateReportingStage(report.Risk?.RiskUpdates?.[0]?.ReportingStageID);
    return (
        <div>
            <DraftReportHeader
                title={`${preHeadingText ?? ''}${report?.Risk?.Title}`}
                reportDate={reportDates?.Next}
                reportingStage={stage}
                customFields={report?.Risk?.CustomFields?.filter(a => a.CustomFieldDfn?.Display).map(a => a.CustomFieldDfn)}
            />
            <div style={{ marginBottom: '15px'/*, fontSize: '12px'*/ }}>
                Reporting period to {DateService.dateToUkLongDate(reportDates?.Next)} and reporting stage is {stage}. {report.Risk?.RiskUpdates?.[0] && <span>Last updated by {report.Risk?.RiskUpdates?.[0].UpdateUser?.Title} on {DateService.dateToUkLongDate(report.Risk?.RiskUpdates?.[0]?.UpdateDate)}. </span>}{props.approvedByText && <span>{props.approvedByText}</span>}
            </div>
            <RiskProgressUpdateReviewList
                {...props}
                risk={report.Risk}
                riskUpdate={(report.Risk as ICorporateRisk)?.RiskUpdates?.[0]}
                onChange={loadReport}
                reportDates={reportDates}
            />
            <RiskMitigationActionProgressUpdateReviewList
                {...props}
                entities={report.RiskMitigationActions?.filter(a => isOpen(a, 'RiskMitigationActionUpdates'))}
                previousEntities={[]}
                reportDates={reportDates}
                risk={report.Risk}
                hideClosedNoUpdates={true}
                onChange={loadReport}
                riskService={dataServices.corporateRiskService}
                riskActionService={dataServices.corporateRiskMitigationActionService}
                riskActionUpdateService={dataServices.corporateRiskMitigationActionUpdateService}
            />
        </div>
    );
};
